"use client";

import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { useMainnetCampaigns } from "./useMainnetCampaigns";
import { useAuth } from "./useAuth";
import { PulsarService } from "@/services/pulsar.service";
import { mapScoresFromDashboard } from "@/lib/mainnet-adapters";

export function useMainnetDashboard() {
  const { isAuthenticated, hasApiToken } = useAuth();
  const campaignsData = useMainnetCampaigns();

  const dashboardQuery = useQuery({
    queryKey: ["mainnet", "dashboard"],
    queryFn: () => PulsarService.getMainnetDashboard(),
    enabled: isAuthenticated && hasApiToken,
    refetchInterval: 30_000,
  });

  const currentUserQuery = useQuery({
    queryKey: ["mainnet", "campaign-user", "spicenet-portal", "1"],
    queryFn: () => PulsarService.getChallengeCampaignUser("spicenet-portal", "1"),
    enabled: isAuthenticated && hasApiToken,
    refetchInterval: 30_000,
  });

  return useMemo(() => {
    const dashboardData = dashboardQuery.data
      ? mapScoresFromDashboard(dashboardQuery.data)
      : {
          legacyScore: 0,
          mainnetScore: 0,
          claimableNowCount: 0,
          activeBoosts: [],
          partners: [],
        };

    return {
      ...campaignsData,
      ...dashboardData,
      leaderboardPosition: currentUserQuery.data?.rank ?? null,
      isLoading:
        campaignsData.isLoading || dashboardQuery.isLoading || currentUserQuery.isLoading,
      isError:
        campaignsData.isError || dashboardQuery.isError || currentUserQuery.isError,
    };
  }, [campaignsData, currentUserQuery.data?.rank, currentUserQuery.isError, currentUserQuery.isLoading, dashboardQuery.data, dashboardQuery.isError, dashboardQuery.isLoading]);
}
